export default __webpack_public_path__ + "static/media/uploader-abbottLibre-problem-2.3b34975d.png";